import { render, staticRenderFns } from "./SubNavigationTabs.vue?vue&type=template&id=25bbabb0"
import script from "./SubNavigationTabs.vue?vue&type=script&lang=js"
export * from "./SubNavigationTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports